import React, { type ReactNode } from 'react';

function ModalOverlay({ onClose }: { onClose: () => void }) {
    return (
        <div
            className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm"
            onClick={onClose}
            aria-hidden="true"
        />
    );
}

export function ModalForm({ children, onClose }: { children: ReactNode; onClose: () => void }) {
    return (
        <div
            className="pointer-events-auto fixed inset-0 z-[100] flex items-center justify-center p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
        >
            <ModalOverlay onClose={onClose} />

            <div className="relative flex max-h-[90vh] w-full max-w-[90vw] flex-col rounded-xl bg-white pt-3 shadow-2xl">
                {children}
            </div>
        </div>
    );
}

export function ModalFormBody({ children }: { children: ReactNode }) {
    return <div className="flex-1 overflow-y-auto p-6">{children}</div>;
}

export function ModalFormFooter({ children }: { children: ReactNode }) {
    return (
        <div className="main-container-new flex flex-shrink-0 items-center justify-end space-x-3 border-t border-gray-200 px-6 py-4">
            {children}
        </div>
    );
}
